var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "format-parameters-editor" }, [
    _vm.foundTags.length > 0
      ? _c("p", [
          _vm._v(
            "\n    The following built-in parameters were detected in the sourcecode "
          ),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.foundTags, function(tag) {
        return _c("span", { staticClass: "mt-2 built-in-tag" }, [
          _vm._v("\n      " + _vm._s(tag) + "\n    ")
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }